import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { createQueryClient } from '@/lib/queryClient';

export interface QueryProviderProps {
  children: ReactNode;
  /** Injectable for tests, which want retries disabled and a fresh cache. */
  client?: QueryClient;
}

export function QueryProvider({ children, client }: QueryProviderProps) {
  // Created in state, not at module scope, so each mounted app gets its own
  // cache. Module-level clients leak data between tests and between users in SSR.
  const [queryClient] = useState(() => client ?? createQueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
